import {UserModel} from "./user.model";

export class DriverModel extends UserModel {
  constructor(data: any) {
    super();
    this.name = data.name;
    if (data.distributor) this.distributor = data.distributor;
    if (data.email) this.email = data.email;
    if (data.location) this.location = data.location;
    this.uid = data.uid || data.id;
    this.phone = data.phone;
    this.role = data.role;
    this.status = data.status;
  }

  uid: string;
  name: string;
  phone: string;
  status: boolean;
  distributor: string;
  location?: {
    date: number,
    lat: number,
    lng: number
  }

}
